import { render, staticRenderFns } from "./proButton.vue?vue&type=template&id=69aa4131&scoped=true&"
import script from "./proButton.vue?vue&type=script&lang=js&"
export * from "./proButton.vue?vue&type=script&lang=js&"
import style0 from "./proButton.vue?vue&type=style&index=0&id=69aa4131&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa4131",
  null
  
)

export default component.exports